import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import "./style.css";

import Navbar from "../../../components/Landing_page_Navbar/index"
import Hero from "./components/Hero";
import TransformativeValue from "./components/TransformativeValue";
import PremiumPackage from "./components/PremiumPackage";
import TacticalScope from "./components/TacticalScope";
import HowItWorks from "./components/HowItWorks";
import SectorExecution from "./components/SectorExecution";
import UnderstandBeforePromoting from "./components/UnderstandBeforePromoting";
import DashboardSection from "./components/DashboardSection";
import Governance from "./components/Governance";
import FinalCta from "./components/FinalCta";
import Footer from "./components/Footer";

export default function Marketingguide() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const updateBackToTopVisibility = () => {
      setShowBackToTop(window.scrollY > 320);
    };

    updateBackToTopVisibility();
    window.addEventListener("scroll", updateBackToTopVisibility, {
      passive: true,
    });
    return () =>
      window.removeEventListener("scroll", updateBackToTopVisibility);
  }, []);

  return (
    <div className="selectezi-page">
      <Navbar />
      <Hero />
      <TransformativeValue />
      <PremiumPackage />
      <TacticalScope />
      <HowItWorks />
      <SectorExecution />
      <UnderstandBeforePromoting />
      <DashboardSection />
      <Governance />
      <FinalCta />
      <Footer />
      <button
        type="button"
        className={`selectezi-marketing-back-to-top${showBackToTop ? " selectezi-marketing-back-to-top--visible" : ""}`}
        aria-label="Back to top"
        title="Back to top"
        tabIndex={showBackToTop ? 0 : -1}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <ArrowUp size={21} strokeWidth={2.2} aria-hidden="true" />
      </button>
    </div>
  );
}
